import { RawGpsMessage } from '@cco/model';
import { createAction, props } from '@ngrx/store';

export const SubscribeToGPSForTruck = createAction(
  '[Truck Live Data] SUBSCRIBE_TO_GPS_FOR_TRUCK',
  props<{ truckUuid: string }>(),
);
export const UnsubscribeFromGPSForTruck = createAction(
  '[Truck Live Data] UNSUBSCRIBE_FROM_GPS_FOR_TRUCK',
  props<{ truckUuid: string }>(),
);
export const ProcessGPSDataForTruck = createAction(
  '[Truck Live Data] PROCESS_GPS_DATA_FOR_TRUCK',
  props<{ truckUuid: string; gpsData: RawGpsMessage[] }>(),
);
export const GetLatestGPSDataForTruck = createAction(
  '[Truck Live Data] GET_LATEST_GPS_DATA_FOR_TRUCK',
  props<{ truckUuid: string }>(),
);
// export const GetLatestGPSDataForAllTrucks = createAction('[TRUCK_LIVE_DATA] GET_LATEST_GPS_DATA_FOR_ALL_TRUCKS');
